import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { awaitukrc63zn80a8 as await_0 } from './afterTimeout.js.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import {
  Companion_instance2oawqq9qiaris as Companion_instance,
  _Result___init__impl__xyqfz83hut4nr3dfvi3 as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
} from '../../../../kotlin-kotlin-stdlib/kotlin/Result.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  intercepted2ogpsikxxj4u0 as intercepted,
  suspendOrReturn49pspzlx5djv as suspendOrReturn,
} from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { CancellableContinuationImpl1cx201opicavg as CancellableContinuationImpl } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/CancellableContinuationImpl.mjs';
import { get_AppScopes4bqeg21n0qw as get_AppScope } from '../../../../reactive/com/lightningkite/reactive/core/AppScope.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { returnIfSuspendedqak8u4r448cu as returnIfSuspended } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coroutineInternalJS.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import {
  isInterface3d6p8outrmvmk as isInterface,
  isCharSequence1ju9jr1w86plq as isCharSequence,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx } from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import {
  contains2el4s70rdq4ld as contains,
  split2bvyvnrlcifjv as split,
  trim11nh7r46at6sx as trim,
  splitToSequence3chmagk9c5yzp as splitToSequence,
  splitToSequence1zhgbvnxlhat1 as splitToSequence_0,
} from '../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { charArrayOf27f4r3dozbrk1 as charArrayOf } from '../../../../kotlin-kotlin-stdlib/kotlin/js/arrays.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import {
  mapsbvh18eqox7a as map,
  filter184huxd00uyfg as filter,
  flatMapgxtanzi5fvh9 as flatMap,
} from '../../../../kotlin-kotlin-stdlib/kotlin/sequences/_Sequences.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import {
  Companion_getInstanceok5aued8gko9 as Companion_getInstance,
  infoOrAbove10o4ftgq7f7ui as infoOrAbove,
} from './debugger.mjs';
import { System_instance3dr57gee6r420 as System_instance } from '../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Clock.mjs';
import { println2shhhgwwt4c61 as println } from '../../../../kotlin-kotlin-stdlib/kotlin/io/console.mjs';
import { emptyMapr06gerzljqtm as emptyMap } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import {
  HttpMethod_GET_getInstance2m1rvu4d8a2j3 as HttpMethod_GET_getInstance,
  ConnectionException1wjs7wwnknnfm as ConnectionException,
  RequestBodyTextpvofjwd95b3y as RequestBodyText,
  RequestBodyFile26cfvm0aih79m as RequestBodyFile,
  RequestBodyBlob1w7e8wxebrdro as RequestBodyBlob,
} from './fetch.mjs';
import { numberToInt1ygmcfwhs2fkq as numberToInt } from '../../../../kotlin-kotlin-stdlib/kotlin/js/numberConversion.mjs';
import { NotImplementedErrorfzlkpv14xxr8 as NotImplementedError } from '../../../../kotlin-kotlin-stdlib/kotlin/Standard.mjs';
import { BasicListenable3uz4a8xs34a0h as BasicListenable } from '../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_killAllSockets() {
  _init_properties_fetch_js_kt__b6zzi5();
  return killAllSockets;
}
var killAllSockets;
function mimeType(_this__u8e3s4) {
  _init_properties_fetch_js_kt__b6zzi5();
  return _this__u8e3s4.type;
}
function *_generator_invoke__zhh2q8($this, $this$launch, $completion) {
  var tmp0 = $this.gdo_1;
  var tmp = $this.hdo_1.jcx_1.response;
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_0 = (tmp instanceof Blob ? tmp : THROW_CCE()).text();
  var tmp_1 = await_0(tmp_0 instanceof Promise ? tmp_0 : THROW_CCE(), $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  // Inline function 'kotlin.coroutines.resume' call
  // Inline function 'kotlin.Companion.success' call
  var value = tmp_1;
  var tmp$ret$1 = _Result___init__impl__xyqfz8(value);
  tmp0.rc(tmp$ret$1);
  return Unit_instance;
}
function *_generator_text__qhd01x($this, $completion) {
  if ($this.jcx_1.readyState === XMLHttpRequest.DONE) {
    var tmp = $this.jcx_1.response;
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = (tmp instanceof Blob ? tmp : THROW_CCE()).text();
    var tmp_1 = await_0(tmp_0 instanceof Promise ? tmp_0 : THROW_CCE(), $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    return tmp_1;
  } else {
    // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine' call
    // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
    var cancellable = new (CancellableContinuationImpl())(intercepted($completion), 1);
    cancellable.ta5();
    var cont = cancellable;
    var handler = (ev) => {
      var tmp = get_AppScope();
      launch(tmp, VOID, VOID, RequestResponse$text$lambda$slambda_0(cont, $this));
      return Unit_instance;
    };
    $this.jcx_1.addEventListener('loadend', handler);
    cont.va7((it) => {
      $this.jcx_1.removeEventListener('loadend', handler);
      return Unit_instance;
    });
    var tmp$ret$2 = cancellable.ua5();
    var tmp_2 = returnIfSuspended(tmp$ret$2, $completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
    return tmp_2;
  }
}
var RequestResponse$text$lambda$slambdaClass;
function RequestResponse$text$lambda$slambda() {
  if (RequestResponse$text$lambda$slambdaClass === VOID) {
    class $ {
      constructor($cont, this$0) {
        this.gdo_1 = $cont;
        this.hdo_1 = this$0;
      }
      yah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    RequestResponse$text$lambda$slambdaClass = $;
  }
  return RequestResponse$text$lambda$slambdaClass;
}
function RequestResponse$text$lambda$slambda_0($cont, this$0) {
  var i = new (RequestResponse$text$lambda$slambda())($cont, this$0);
  var l = ($this$launch, $completion) => i.yah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
function RequestResponse$headers$delegate$lambda$lambda(it) {
  return contains(it, _Char___init__impl__6a9atx(58));
}
function RequestResponse$headers$delegate$lambda$lambda_0(it) {
  var s = split(it, [':']);
  // Inline function 'kotlin.text.trim' call
  var this_0 = s.q1(1);
  var tmp$ret$0 = toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
  var tmp = splitToSequence(tmp$ret$0, charArrayOf([_Char___init__impl__6a9atx(59)]));
  return map(tmp, (it) => {
    // Inline function 'kotlin.text.trim' call
    var this_0 = s.q1(0);
    var tmp$ret$1 = toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
    return to(tmp$ret$1, it);
  });
}
var RequestResponseClass;
function RequestResponse() {
  if (RequestResponseClass === VOID) {
    class $ {
      constructor(wraps) {
        this.jcx_1 = wraps;
        var tmp = this;
        tmp.kcx_1 = lazy(() => {
          var tmp = splitToSequence_0(this.jcx_1.getAllResponseHeaders(), ['\r\n']);
          var tmp_0 = filter(tmp, RequestResponse$headers$delegate$lambda$lambda);
          return httpHeaders_0(flatMap(tmp_0, RequestResponse$headers$delegate$lambda$lambda_0));
        });
      }
      lcx() {
        return this.jcx_1.status;
      }
      ido() {
        return (this.jcx_1.status / 100 | 0) === 2;
      }
      jdo($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_text__qhd01x.bind(VOID, this), $completion);
      }
    }
    initMetadataForClass($, 'RequestResponse', VOID, VOID, VOID, [0]);
    RequestResponseClass = $;
  }
  return RequestResponseClass;
}
function fileName(_this__u8e3s4) {
  _init_properties_fetch_js_kt__b6zzi5();
  return _this__u8e3s4.name;
}
function toBlob(_this__u8e3s4, contentType) {
  contentType = contentType === VOID ? 'text/plain' : contentType;
  _init_properties_fetch_js_kt__b6zzi5();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp = [_this__u8e3s4];
  // Inline function 'org.w3c.files.BlobPropertyBag' call
  var o = {};
  o['type'] = contentType;
  return new Blob(tmp, o);
}
function httpHeaders(list) {
  _init_properties_fetch_js_kt__b6zzi5();
  // Inline function 'kotlin.apply' call
  var this_0 = new Headers();
  var _iterator__ex2g4s = list.m1();
  while (_iterator__ex2g4s.n1()) {
    var entry = _iterator__ex2g4s.o1();
    this_0.append(entry.af_1, entry.bf_1);
  }
  return this_0;
}
function websocket(url) {
  _init_properties_fetch_js_kt__b6zzi5();
  return new (WebSocketWrapper())(new WebSocket(url));
}
function httpHeaders_0(sequence) {
  _init_properties_fetch_js_kt__b6zzi5();
  // Inline function 'kotlin.apply' call
  var this_0 = new Headers();
  var _iterator__ex2g4s = sequence.m1();
  while (_iterator__ex2g4s.n1()) {
    var entry = _iterator__ex2g4s.o1();
    this_0.append(entry.af_1, entry.bf_1);
  }
  return this_0;
}
var WebSocketWrapperClass;
function WebSocketWrapper() {
  if (WebSocketWrapperClass === VOID) {
    class $ {
      constructor(native, log) {
        log = log === VOID ? infoOrAbove(Companion_getInstance().bbn('WS to ' + native.url)) : log;
        this.kdo_1 = native;
        this.ldo_1 = log;
        this.mdo_1 = System_instance.b1m();
        var tmp = this;
        var tmp_0 = get_killAllSockets();
        tmp.ndo_1 = tmp_0.vah(() => {
          println('Killing websocket to ' + this.kdo_1.url + ' opened at ' + this.mdo_1.toString());
          this.kdo_1.close(3008);
          return Unit_instance;
        });
        this.udl((it) => {
          this.ndo_1();
          return Unit_instance;
        });
        var tmp0_safe_receiver = this.ldo_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          var log_0 = tmp0_safe_receiver;
          this.tdl(() => {
            log_0.cbn(['Opened.']);
            return Unit_instance;
          });
          this.vdl((it) => {
            log_0.hcv(['onMessage ' + it]);
            return Unit_instance;
          });
          this.wdl((it) => {
            log_0.hcv(['onBinaryMessage ' + toString(it)]);
            return Unit_instance;
          });
          this.udl((it) => {
            log_0.cbn(['Closed with code ' + it + '.']);
            return Unit_instance;
          });
        }
      }
      pdn(code, reason) {
        return this.kdo_1.close(code, reason);
      }
      rdn(data) {
        return this.kdo_1.send(data);
      }
      tdl(action) {
        this.kdo_1.addEventListener('open', (it) => {
          action();
          return Unit_instance;
        });
      }
      vdl(action) {
        this.kdo_1.addEventListener('message', (it) => {
          if (!(it instanceof MessageEvent))
            THROW_CCE();
          var tmp = it.data;
          var tmp0_safe_receiver = (!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : null;
          if (tmp0_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            action(tmp0_safe_receiver);
          }
          return Unit_instance;
        });
      }
      wdl(action) {
        this.kdo_1.addEventListener('message', (it) => {
          if (!(it instanceof MessageEvent))
            THROW_CCE();
          var tmp = it.data;
          var tmp0_safe_receiver = tmp instanceof Blob ? tmp : null;
          if (tmp0_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            action(tmp0_safe_receiver);
          }
          return Unit_instance;
        });
      }
      udl(action) {
        this.kdo_1.addEventListener('close', (it) => {
          action((it instanceof CloseEvent ? it : THROW_CCE()).code);
          return Unit_instance;
        });
      }
    }
    initMetadataForClass($, 'WebSocketWrapper');
    WebSocketWrapperClass = $;
  }
  return WebSocketWrapperClass;
}
function httpHeaders_1(map) {
  var tmp;
  if (map === VOID) {
    // Inline function 'kotlin.collections.mapOf' call
    tmp = emptyMap();
  } else {
    tmp = map;
  }
  map = tmp;
  _init_properties_fetch_js_kt__b6zzi5();
  // Inline function 'kotlin.apply' call
  var this_0 = new Headers();
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s = map.d2().m1();
  while (_iterator__ex2g4s.n1()) {
    var entry = _iterator__ex2g4s.o1();
    this_0.append(entry.e2(), entry.f2());
  }
  return this_0;
}
function fetch(url, method, headers, body, onUploadProgress, onDownloadProgress, $completion) {
  method = method === VOID ? HttpMethod_GET_getInstance() : method;
  headers = headers === VOID ? httpHeaders_1() : headers;
  body = body === VOID ? null : body;
  onUploadProgress = onUploadProgress === VOID ? null : onUploadProgress;
  onDownloadProgress = onDownloadProgress === VOID ? null : onDownloadProgress;
  var cancellable = new (CancellableContinuationImpl())(intercepted($completion), 1);
  cancellable.ta5();
  var cont = cancellable;
  var request = new XMLHttpRequest();
  if (onUploadProgress == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    var p = onUploadProgress;
    var tmp = request.upload;
    tmp.addEventListener('progress', (event) => {
      if (!(event instanceof ProgressEvent))
        THROW_CCE();
      var tmp = numberToInt(event.loaded);
      // Inline function 'kotlin.let' call
      var it = numberToInt(event.total);
      var tmp$ret$1 = it === 0 ? -1 : it;
      p(tmp, tmp$ret$1);
      return Unit_instance;
    });
  }
  if (onDownloadProgress == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    var p_0 = onDownloadProgress;
    request.addEventListener('progress', (event) => {
      if (!(event instanceof ProgressEvent))
        THROW_CCE();
      var tmp = numberToInt(event.loaded);
      // Inline function 'kotlin.let' call
      var it = numberToInt(event.total);
      var tmp$ret$5 = it === 0 ? -1 : it;
      p_0(tmp, tmp$ret$5);
      return Unit_instance;
    });
  }
  // Inline function 'org.w3c.xhr.BLOB' call
  // Inline function 'kotlin.js.asDynamic' call
  // Inline function 'kotlin.js.unsafeCast' call
  request.responseType = 'blob';
  request.open(method.a4_1, url);
  forEach(headers, (key, value) => {
    request.setRequestHeader(key, value);
    return Unit_instance;
  });
  request.onloadend = (ev) => {
    var tmp;
    if (request.status >= 100) {
      var tmp0 = cont;
      // Inline function 'kotlin.coroutines.resume' call
      // Inline function 'kotlin.Companion.success' call
      var value = new (RequestResponse())(request);
      var tmp$ret$11 = _Result___init__impl__xyqfz8(value);
      tmp0.rc(tmp$ret$11);
      tmp = Unit_instance;
    } else {
      var tmp0_0 = cont;
      // Inline function 'kotlin.coroutines.resumeWithException' call
      // Inline function 'kotlin.Companion.failure' call
      var exception = ConnectionException().ocx('Connection failed');
      var tmp$ret$13 = _Result___init__impl__xyqfz8(createFailure(exception));
      tmp0_0.rc(tmp$ret$13);
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
  if (body == null) {
    request.send();
  } else {
    if (body instanceof RequestBodyBlob()) {
      request.setRequestHeader('Content-Type', body.odo_1.type);
      request.send(body.odo_1);
    } else {
      if (body instanceof RequestBodyFile()) {
        request.setRequestHeader('Content-Type', body.ucx_1.type);
        request.send(body.ucx_1);
      } else {
        if (body instanceof RequestBodyText()) {
          request.setRequestHeader('Content-Type', body.tcx_1);
          request.send(body.scx_1);
        } else {
          throw NotImplementedError().qd();
        }
      }
    }
  }
  cont.va7((it) => {
    request.abort();
    return Unit_instance;
  });
  return cancellable.ua5();
}
function forEach(_this__u8e3s4, action) {
  _init_properties_fetch_js_kt__b6zzi5();
  // Inline function 'kotlin.js.asDynamic' call
  var keys = _this__u8e3s4.keys();
  var nextKey;
  do {
    nextKey = keys.next();
    if (nextKey.value != null && nextKey.value != undefined) {
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.unsafeCast' call
      var nextValue = _this__u8e3s4.get(nextKey.value);
      action(nextKey.value, nextValue);
    }
  }
   while (!nextKey.done);
}
var properties_initialized_fetch_js_kt_ug494v;
function _init_properties_fetch_js_kt__b6zzi5() {
  if (!properties_initialized_fetch_js_kt_ug494v) {
    properties_initialized_fetch_js_kt_ug494v = true;
    // Inline function 'kotlin.also' call
    var this_0 = BasicListenable().paq();
    var it = this_0;
    // Inline function 'kotlin.js.asDynamic' call
    window.killAllSockets = () => {
      println('Killing all sockets');
      it.qaq();
      return Unit_instance;
    };
    killAllSockets = this_0;
  }
}
//region block: exports
export {
  fileName as fileName15g5pzin3s3wj,
  httpHeaders_1 as httpHeaders3s629sxokj9k6,
  httpHeaders as httpHeaders1p0c4h1mvk3o7,
  mimeType as mimeType31eog9gy5012s,
  toBlob as toBlob3efqyqa0phgb9,
  websocket as websocket1qipdxwrf95zh,
  fetch as fetch3uvmq4t9tt42y,
};
//endregion

//# sourceMappingURL=fetch.js.mjs.map
